import React from "react";

export default function LifecycleTracker({ wf, step, started, onJump, approvals = {} }) {
  const total = wf.steps.length;
  const fill = started ? (step / (total - 1)) * 100 : 0;
  const current = wf.steps[step];

  return (
    <>
      <div className="lcx-box-head">
        <span className="t">{wf.icon} {wf.name}</span>
        <span className="lcx-docid">{wf.docId}</span>
      </div>

      <div className="lcx-track">
        <div className="lcx-track-bar"><div className="lcx-track-fill" style={{ width: `${fill}%` }} /></div>
        <div className="lcx-nodes">
          {wf.steps.map((s, i) => {
            const state = !started ? "future" : i < step ? "done" : i === step ? "now" : "future";
            return (
              <button key={s.label} type="button" className={`lcx-node ${state}`} onClick={() => onJump(i)}>
                <span className="c">{state === "done" ? "✓" : i + 1}</span>
                <span className="lbl">{s.label}</span>
              </button>
            );
          })}
        </div>
      </div>

      <div className="lcx-detail">
        {started ? (
          <>
            <div className="row1">
              <span className="s-icon">{current.icon}</span>
              <span className="s-name">{current.label}</span>
              <span className="s-reg">{current.reg}</span>
            </div>
            <p className="s-desc">{current.desc}</p>
            <div className="lcx-agent">
              <span className="dot" />
              <span className="msg">{current.agent}</span>
            </div>
            {current.gate && (
              approvals[step] ? (
                <div className="lcx-gate" style={{ borderColor: "#1E9E9E", color: "#4FC3C3" }}>
                  ✅ HUMAN APPROVED — e-signed by {approvals[step].name} at {new Date(approvals[step].time).toLocaleTimeString()}
                </div>
              ) : (
                <div className="lcx-gate">
                  🚦 HUMAN-IN-THE-LOOP GATE — AI cannot proceed without human review and e-signature
                </div>
              )
            )}
          </>
        ) : (
          <p className="s-desc">Press ▶ Run Demo to watch the full governed lifecycle — AI drafts · humans validate.</p>
        )}
      </div>
    </>
  );
}